<template>
  <v-container>
    <v-card class="pa-2 tablecard d-flex flex-column">
    <v-row class="flex-shrink-0">
      <v-col>
        <!-- By customer request, deal with discrete inhabitant numbers and operators -->
        <div>
          <p class="text-button button-spacer">Einwohnerzahl</p>
          <v-btn @click="einwohnerFilterGreater = !einwohnerFilterGreater">
            {{ einwohnerFilterGreater ? 'größer' : 'kleiner' }}
          </v-btn>
          <v-btn @click="einwohnerValueHandler">{{ einwohnerValue.toLocaleString() }}</v-btn>
        </div>
      </v-col>
      <!-- Toggle other attribute filters by cycling the resp reactive value -->
      <v-col>
        <div>
          <p class="text-button button-spacer">Wärmeplanung im Konvoi</p>
          <v-btn @click="cycleValue('bl_konvoi')">{{ boolToLang(bl_konvoi) }}</v-btn>
        </div>
      </v-col>
      <v-col>
      <div>
        <p class="text-button button-spacer">Vereinfachtes Verfahren</p>
        <v-btn @click="cycleValue('bl_vereinfacht')">{{ boolToLang(bl_vereinfacht) }}</v-btn>
      </div>
      </v-col>
      <v-col>
        <div>
          <p class="text-button button-spacer">Verkürztes Verfahren</p>
          <v-btn @click="cycleValue('bl_verkuerzt')">{{ boolToLang(bl_verkuerzt) }}</v-btn>
        </div>
      </v-col>
      <v-col>
      <div>
        <p class="text-button button-spacer">Maßnahmen vorhanden</p>
        <v-btn @click="cycleValue('bl_measures')">{{ boolToLang(bl_measures) }}</v-btn>
      </div>
      </v-col>
      <v-col>
      <div>
        <p class="text-button button-spacer">Maßnahmen-Themen</p>
        <v-select
          label="Themen Filtern"
          :items=measuresOptions
          item-text="title"
          item-value="value"
          v-model="selectedMeasure"
        ></v-select>
      </div>
      </v-col>
    <!-- The actual table -->
    </v-row>
    <v-divider></v-divider>

      <v-card-title class="text--primary py-0">
      Kommunen
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        label="Suche"
        append-icon="mdi-magnify"
        class="mb-4"
      ></v-text-field>
      </v-card-title>
      <v-card-text class="pa-0 table-container">
      <v-data-table
        density="compact"
        :expanded="expanded"
        dense
        :headers="headers"
        :items="modifiedData"
        item-value="plz"
        item-key="plz"
        :items-per-page="25"
        hover
        multi-sort
        show-expand
        fixed-header
        height=350
      >
      <template #item.data-table-expand="{ item, expand, isExpanded }">
        <!-- Attention: We are using the modified (Plain language attr) here for dev. Change when there is a col with the actual measures and then check that -->
        <td v-if="item.bl_measures ==='Ja'" class="text-start">
          <v-btn icon
                 ref="expandBtn"
                 @click="expand(!isExpanded)"
                 class="v-data-table__expand-icon"
                 :class="{'v-data-table__expand-icon--active' : isExpanded}">
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </td>
      </template>
      <!-- Expansion TD for measures -->
      <template v-slot:expanded-item="{ headers, item }" >
        <td :colspan="headers.length" class="pa-0 rounded-0">
          <div v-for="(el) in JSON.parse(item.measures)"
            :key="el.mn_title">
            <v-card>
              <v-card-title>
                Titel der Maßnahme: {{ el.mn_title }}
              </v-card-title>
              <v-col>
                <v-img
                  max-width="300"
                  :src="el.mn_img"
                  :alt="el.mn_title"
                ></v-img>
              </v-col>
              <v-list-item dense>
                <v-list-item-content>
                  Maßnahmen-Kategorie:
                  {{ el.mn_oberthema }} |
                  {{ el.mn_mittelthema }} |
                  {{ el.mn_unterthema }}
                  <br>
                  Zeitraum: {{ parseDate(el.mn_start) }} bis  {{ parseDate(el.mn_end) }}
                  <br>
                  Kosten: {{ el.mn_cost.toLocaleString() }} €
                </v-list-item-content>
              </v-list-item>
              <v-card-text>{{ el.mn_text }} </v-card-text>
              <v-list-item dense>
                <v-list-item-content>
                  Ansprechpartner: {{ el.mn_name_anspr }} <br>
                  Rolle Anspr.: {{ el.mn_email_anspr }} <br>
                  Kontakt Anspr.: {{ el.mn_role_anspr }} <br>
                </v-list-item-content>
              </v-list-item>
            </v-card>
            <v-divider></v-divider>
          </div>
        </td>
      </template>
      <!-- Highlighting on name and convoy members. We are essentially replacing the text so need to re-capitalize it either way  -->
    <template #item.name_gemeinde="{ value }">
        <div v-if="search.length > 1" :inner-html.prop="value | highlight(search) | capitalize"></div>
        <div v-else :inner-html.prop="value | capitalize"></div>
    </template>
    <template #item.convoy_nachbarn="{ value }">
        <div v-if="search.length > 1" :inner-html.prop="value | highlight(search) | capitalize"></div>
        <div v-else :inner-html.prop="value | capitalize"></div>
    </template>
    <template #[`item.wp_url`]="{ value,item }">
    <a target="_blank" :href="value">
      Wärmeplan {{item.city_name}} (extern)
    </a>
  </template>

    </v-data-table>
    </v-card-text>

    </v-card>

  </v-container>
</template>

<script>
import { Mapable } from '../../../src/mixins/Mapable';
import Style from 'ol/style/Style';
import Icon from 'ol/style/Icon';
import { WguEventBus } from '../../../src/WguEventBus';

const BOOL_LABEL = { true: 'Ja', false: 'Nein', null: 'Alle' };

// const ICON_STYLES = {
//   measures: new Style({ image: new Icon({ src: './static/icon/location_green.svg', declutterMode: 'declutter' }) }),
//   kennzahlen: new Style({ image: new Icon({ src: './static/icon/location_blue.svg', declutterMode: 'declutter' }) }),
//   basic: new Style({ image: new Icon({ src: './static/icon/location_red.svg', declutterMode: 'declutter' }) }),
//   hidden: new Style({})
// };

export default {
  name: 'vue-table',
  mixins: [Mapable],
  created () {
    WguEventBus.$on('city-value', (cityValue) => {
      this.search = cityValue;
      this.triggerExpand();
    });
  },
  props: {
    externalSearch: { type: String, required: false, default: '' }
  },
  data () {
    return {
      layerID: 'fvp_waermeplan',
      layerFeatures: [],
      layerAttributes: [],
      vectorSource: null,
      search: this.externalSearch,
      expanded: [],
      einwohnerValue: 0,
      einwohnerOptions: [0, 10000, 100000],
      einwohnerFilterGreater: true,
      measuresOptions: [
        { title: 'Ausbau Erneuerbare Energien', value: 'Ausbau Erneuerbare Energien' },
        { title: 'Energieeffizienz', value: 'Energieeffizienz' },
        { title: 'Begleitende Maßnahmen, Konzepte und Kommunikation', value: 'Begleitende Maßnahmen, Konzepte und Kommunikation' },
        { title: 'Sonstiges', value: 'Sonstiges' },
        { title: '[Kein Filter]', value: null }
      ],
      selectedMeasure: null,
      bl_konvoi: null,
      bl_vereinfacht: null,
      bl_verkuerzt: null,
      bl_measures: null,
      headers: [
        {
          text: 'Name',
          value: 'name_gemeinde',
          key: 'name_gemeinde',
          sortable: true
        },
        {
          text: 'PLZ',
          value: 'plz',
          key: 'plz',
          sortable: true
        },

        {
          text: 'Landkreis',
          value: 'name_lkr',
          key: 'name_lkr',
          sortable: true
        },

        {
          text: 'Einwohnerzahl',
          value: 'bevoelkerung',
          key: 'bevoelkerung',
          sortable: true
        },
        {
          text: 'Im Konvoi',
          value: 'bl_konvoi',
          key: 'bl_konvoi',
          sortable: true
        },
        {
          text: 'Konvoi-Partner',
          value: 'convoy_nachbarn',
          key: 'convoy_nachbarn',
          sortable: true
        },
        {
          text: 'Vereinfachtes Verfahren',
          value: 'bl_vereinfacht',
          key: 'bl_vereinfacht',
          sortable: true
        },
        {
          text: 'Verkürztes Verfahren',
          value: 'bl_verkuerzt',
          key: 'bl_verkuerzt',
          sortable: true
        },
        {
          text: 'Link Wärmeplan',
          value: 'wp_url',
          key: 'wp_url',
          sortable: true
        },
        {
          text: 'Datum Veröffentlichung',
          value: 'veroeffentlicht_locale',
          key: 'veroeffentlicht_locale',
          sortable: false
        },
        {
          text: 'Maßnahmen veröffentlicht',
          value: 'bl_measures',
          key: 'bl_measures',
          sortable: true
        },
        // Expansion column
        { text: 'Maßnahmen', value: 'data-table-expand' }
      ]
    };
  },
  methods: {

    /*
      Attribute filter button content from bool to human language
      TODO: i18n
    */
    boolToLang (input) {
      return BOOL_LABEL[input];
    },
    /*
      Cycle the attribute button values between true false or deletion from criteria
    */
    cycleValue (key) {
      const CYCLE = { null: true, true: false, false: null };
      this[key] = CYCLE[this[key]];
    },
    /*
      Run data requests and filters first time to fill table
    */
    async onMapBound () {
      await this.getGeoJsonFromUrl();
      this.getVectorSource();
      this.getLayerFeatures();
      this.adjustIcons();
    },
    /*
      Get vector source
    */
    getVectorSource () {
      const vectorLayer = this.map.getLayers().getArray().find(l => l.get('lid') === this.layerID);
      this.vectorSource = vectorLayer.getSource();
    },
    /*
      Get the features from the target vector layer
    */
    async getLayerFeatures () {
      try {
        this.layerFeatures = this.vectorSource.getFeatures();
        this.layerFeatures.forEach(feature => {
          this.layerAttributes.push(feature.getProperties());
        });
      } catch (error) {
        console.error('Failed to fetch WFS data:', error);
      }
    },
    /*
      Retrieve GeoJSON from WFS endpoint and extract features and properties
    */
    async getGeoJsonFromUrl () {
      try {
        const url = 'https://waermeplaene-hessen.de/geoserver/postgis_kwp_input/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=postgis_kwp_input%3Afvp_waermeplan&maxFeatures=500&outputFormat=application%2Fjson';
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const geojson = await response.json();

        // Extract features and their properties
        if (geojson.features && Array.isArray(geojson.features)) {
          geojson.features.forEach((feature) => {
            if (feature.properties) {
              this.layerAttributes.push(feature.properties);
            }
          });
        }
      } catch (error) {
        console.error('Failed to fetch GeoJSON data:', error);
      }
    },
    /*
      Loop over the different possible inhabitant filter values as per customer request
    */
    einwohnerValueHandler () {
      const currentIndex = this.einwohnerOptions.indexOf(this.einwohnerValue);
      this.einwohnerValue = this.einwohnerOptions[(currentIndex + 1) % this.einwohnerOptions.length];
    },
    /*
    * Filter out features that do not match the search filters
    */
    adjustIcons () {
      const measuresStyle = new Style({
        image: new Icon({
          src: './static/icon/location_green.svg',
          declutterMode: 'declutter'
        })
      });
      const kennzahlenStyle = new Style({
        image: new Icon({
          src: './static/icon/location_blue.svg',
          declutterMode: 'declutter'
        })
      });
      const basicStyle = new Style({
        image: new Icon({
          src: './static/icon/location_red.svg',
          declutterMode: 'declutter'
        })
      });

      const lowerSearch = this.search.toLowerCase();

      this.vectorSource.getFeatures().forEach((feature) => {
        const featureName = feature.get('city_name');
        const hasMeasures = feature.get('bl_measures');
        const hasKennzahlen = feature.get('bl_kennzahlen');
        const measures = feature.get('measures');
        const verkuerzt = feature.get('bl_verkuerzt');
        const vereinfacht = feature.get('bl_vereinfacht');
        const konvoi = feature.get('bl_konvoi');
        const bevoelkerung = feature.get('bevoelkerung');
        /*
          Always set styles
          Then set everything that does not match as empty style
        */
        if (hasMeasures) {
          feature.setStyle(measuresStyle)
        } else if (hasKennzahlen) {
          feature.setStyle(kennzahlenStyle)
        } else {
          feature.setStyle(basicStyle)
        }
        // Text search
        if (this.search && !featureName.toLowerCase().includes(lowerSearch)) {
          feature.setStyle(new Style({}))
        }

        // Feature search
        // Check if condition is in filtercriteria and set invisible if not
        if (
          (this.filterCriteria.bl_verkuerzt != null && verkuerzt === !this.filterCriteria.bl_verkuerzt) ||
          (this.filterCriteria.bl_vereinfacht != null && vereinfacht === !this.filterCriteria.bl_vereinfacht) ||
          (this.filterCriteria.bl_konvoi != null && konvoi === !this.filterCriteria.bl_konvoi) ||
          (this.filterCriteria.bl_measures != null && hasMeasures === !this.filterCriteria.bl_measures)
        ) {
          feature.setStyle(new Style({}));
        }

        if (measures) {
          // if a measure is selected and if the measures does NOT contain its current value
          if (this.selectedMeasure && !JSON.parse(measures).some(m => m.mn_oberthema === this.selectedMeasure)) {
            feature.setStyle(new Style({}));
          }
        } else if (this.selectedMeasure) {
          feature.setStyle(new Style({}));
        }

        // Pop search
        if (this.einwohnerFilterGreater && bevoelkerung < this.einwohnerValue) {
          feature.setStyle(new Style({}));
        } else if (!this.einwohnerFilterGreater && bevoelkerung > this.einwohnerValue) {
          feature.setStyle(new Style({}));
        }
      });
    },
    /*
      Filtering on text search
    */
    textFilter () {
      if (this.search) {
        const searchLower = this.search.toLowerCase();
        this.textSearchData = this.layerAttributes.filter((item) =>
          Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchLower)
          )
        );
      } else {
        this.textSearchData = this.layerAttributes; // Reset if no search term
      }
    },
    /*
      Filtering on attribute buttons
      Fed by what is inside filterCriteria
    */
    attrFilter () {
      this.textFilter();
      // If a filter on attrs or measures was selected
      if (Object.keys(this.filterCriteria).length > 0 || this.selectedMeasure) {
        // Filter on data already filtered on previous  text search
        this.attrSearchData = this.textSearchData.filter(attr => {
          // Check if any of the datas kvp match any filter criteria
          return Object.keys(this.filterCriteria).every(key => {
            return attr[key] === this.filterCriteria[key];
          });
        })
        // .filter(obj => {
        //   if (obj.measures) {
        //     const meas = JSON.parse(obj.measures);
        //     return meas.some(item => item.mn_oberthema === this.selectedMeasure);
        //   } else return true
        // });
      } else this.attrSearchData = this.textSearchData;
    },
    /**
     * Filter on measures which are their own attached json obj to each row
     */
    measureFilter () {
      this.attrFilter();
      if (!this.selectedMeasure) return;
      this.attrSearchData = this.attrSearchData.filter(obj => {
        if (obj.measures) {
          const meas = JSON.parse(obj.measures);
          return meas.some(item => item.mn_oberthema === this.selectedMeasure);
        } else return false;
      });
    },
    parseDate (dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString('de-DE');
    },
    triggerExpand () {
      // Access the ref and trigger the click event
      if (this.search && this.$refs.expandBtn) {
        this.$refs.expandBtn.$el.click();
      }
    }
  },
  computed: {
    filteredData () {
      const lowerSearch = this.search.toLowerCase();
      return this.layerAttributes.filter(item => {
        if (this.search && !Object.values(item).some(v => String(v).toLowerCase().includes(lowerSearch))) {
          return false;
        }
        if (this.bl_konvoi !== null && item.bl_konvoi !== this.bl_konvoi) return false;
        if (this.bl_vereinfacht !== null && item.bl_vereinfacht !== this.bl_vereinfacht) return false;
        if (this.bl_verkuerzt !== null && item.bl_verkuerzt !== this.bl_verkuerzt) return false;
        if (this.bl_measures !== null && item.bl_measures !== this.bl_measures) return false;
        if (this.einwohnerValue > 0) {
          if (this.einwohnerFilterGreater && item.bevoelkerung < this.einwohnerValue) return false;
          if (!this.einwohnerFilterGreater && item.bevoelkerung > this.einwohnerValue) return false;
        }
        if (this.selectedMeasure) {
          if (!item.measures) return false;
          if (!JSON.parse(item.measures).some(m => m.mn_oberthema === this.selectedMeasure)) return false;
        }
        return true;
      });
    },
    modifiedData () {
      return this.filteredData.map(obj => {
        const updatedObj = {
          ...obj,
          veroeffentlicht_locale: obj.veroeffentlicht,
          convoy_nachbarn: (JSON.parse(obj.convoy_nachbarn) ?? []).join(', '), // Array to separate Strings. JSON.parse so empty array becomes empty string, not null, which causes an error with .join
          bevoelkerung: obj.bevoelkerung.toLocaleString()
        };

        // Convert boolean properties to "Ja" / "Nein"
        for (const key in updatedObj) {
          if (typeof updatedObj[key] === 'boolean') {
            updatedObj[key] = updatedObj[key] ? 'Ja' : 'Nein';
          }
        }
        return updatedObj;
      });
    }
  },
  watch: {
    filteredData () {
      this.adjustIcons();
    }
  },
  filters: {
    highlight (value, query) {
      const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return value.replace(new RegExp(escaped, 'ig'), match => `<span class='red'>${match}</span>`);
    },
    capitalize (value) {
      if (!value) return '';
      const str = value.toString();
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  }
};
</script>

<style scoped>

.text-button {
  font-size: smaller !important;
}

</style>
